import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { CART_STATE_KEY, CartState } from '../state';

export const selectCartState: MemoizedSelector<object, CartState> =
  createFeatureSelector<CartState>(CART_STATE_KEY);

// eslint-disable-next-line @typescript-eslint/typedef
export const selectCartId = createSelector(
  selectCartState,
  (state: CartState) => state.cartId,
);

// eslint-disable-next-line @typescript-eslint/typedef
export const selectCart = createSelector(
  selectCartState,
  (state: CartState) => state.cartData,
);

// eslint-disable-next-line @typescript-eslint/typedef
export const selectCartQueue = createSelector(
  selectCartState,
  (state: CartState) => state.cartQueue,
);

// eslint-disable-next-line @typescript-eslint/typedef
export const selectIsCartQueueProcessing = createSelector(
  selectCartState,
  (state: CartState) => state.isCartQueueProcessing,
);
